<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zFLLj7/images/cover.jpg?1684274264772" alt="This image is the cover for the book The Book of Revelation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Book of Revelation
      </h1>
      <p class="bookDescription body article font2">
        <p>Medieval exegesis of the Apocalypse from Richard of St. Victor through Nicolas of Lyra</p><p>In this volume Franciscan scholar David Burr concentrates on the mendicant contribution to the book of Revelation. Clashing interpretive strategies developed, mirroring authority structures in the context of the new institutional framework of the university, the new methodology of scholasticism, and expanding papal authority. By the early fourteenth century a clear victory of one strategy and one structure emerges in the work of Pierre Auriol and Nicholas of Lyra, and, conversely, the defeat of another in the posthumous condemnations of Petrus Iohannis Olivi and, to some extent, Joachim of Fiore. </p><p>This is the fifth volume of The Bible in Medieval Tradition (BMT), a series designed to reconnect the church with part of its rich history of biblical interpretation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David D. Burr
      </h2>
      
      <p class="authorDescription body article"><BR /><B>David Burr</B>&#160;(PhD, Duke University) is professor emeritus of history at Virginia Tech. He received the St. Bonaventure medal for lifetime achievement in Franciscan studies in 2005 and is currently working on a critical edition of Petrus Iohannis Olivi&#39;s commentary on the gospel of Matthew.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b649201